export default __webpack_public_path__ + "static/media/pinterest-icon.a7ff96fd.svg";